import { render, staticRenderFns } from "./Chips.vue?vue&type=template&id=02855df2&scoped=true&"
import script from "./Chips.vue?vue&type=script&lang=js&"
export * from "./Chips.vue?vue&type=script&lang=js&"
import style0 from "./Chips.vue?vue&type=style&index=0&id=02855df2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02855df2",
  null
  
)

export default component.exports